// src/views/ViewStockSalesDetails.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockSalesService from "../services/StockSalesService";
import Loading from "../components/loading";

export default function ViewStockSalesDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await StockSalesService.getById(id);
      const data = res?.data?.data?.details || [];
      setRows(data);
    } catch (err) {
      console.error("Error loading StockSales details:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock Sales Details" secondTitle="Inventory" />

      <button
        type="button"
        className="btn btn-secondary"
        style={{ margin: "10px" }}
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <div className="card p-3 bg-white shadow-sm">
        <h4>Item Details</h4>
        <div className="table-responsive">
          {loading ? (
            <div className="text-center py-4">
              <Loading />
            </div>
          ) : (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Item Category</th>
                  <th>Item Code</th>
                  <th>Item Name</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                </tr>
              </thead>

              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, idx) => (
                    <tr key={idx}>
                      <td>{r.itemCategoryName || r.categoryName || r.itemCategory || "-"}</td>
                      <td>{r.itemCode}</td>
                      <td>{r.itemName}</td>
                      <td>{r.UOM}</td>
                      <td>{Number(r.quantity).toFixed(3)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
